import { useEffect, useState } from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { fetchArticleComments } from '../../services/commentService';

import CommentItem from './CommentItem';

import Spinner from '../ui/Spinner';



const Section = styled.section`

  margin-top: 2.5rem;

  padding-top: 2rem;

  border-top: 1px solid ${({ theme }) => theme.colors.border};

`;



const Title = styled.h2`

  font-family: ${({ theme }) => theme.typography.fonts.display};

  font-size: 1.375rem;

  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};

  margin: 0 0 1.25rem;

  color: ${({ theme }) => theme.colors.foreground};

`;



const Empty = styled.p`

  margin: 0;

  color: ${({ theme }) => theme.colors.mutedForeground};

  font-size: 0.9375rem;

`;



const Count = styled.span`

  font-size: 0.875rem;

  font-weight: 500;

  color: ${({ theme }) => theme.colors.mutedForeground};

  margin-left: 0.5rem;

`;



const LoadingWrap = styled.div`

  display: flex;

  justify-content: center;

  padding: 1.5rem 0;

`;



export default function CommentList({ articleId, refreshKey = 0, onReply, commentCount }) {

  const { t } = useTranslation();

  const [comments, setComments] = useState([]);

  const [total, setTotal] = useState(0);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);



  useEffect(() => {

    if (!articleId) return undefined;

    let cancelled = false;



    (async () => {

      setLoading(true);

      setError(null);

      try {

        const res = await fetchArticleComments(articleId, { sort: 'oldest', limit: 50 });

        if (!cancelled) {

          setComments(res.data || []);

          setTotal(res.commentCount ?? res.total ?? 0);

        }

      } catch (e) {

        if (!cancelled) {

          setError(e?.response?.data?.message || t('comments.loadError'));

          setComments([]);

          setTotal(0);

        }

      } finally {

        if (!cancelled) setLoading(false);

      }

    })();



    return () => {

      cancelled = true;

    };

  }, [articleId, refreshKey, t]);



  const displayCount = commentCount ?? total;



  return (

    <Section aria-labelledby="comments-heading">

      <Title id="comments-heading">

        {t('comments.title')}

        {!loading && displayCount > 0 ? <Count>({displayCount})</Count> : null}

      </Title>



      {loading ? (

        <LoadingWrap>

          <Spinner />

        </LoadingWrap>

      ) : error ? (

        <Empty>{error}</Empty>

      ) : comments.length === 0 ? (

        <Empty>{t('comments.empty')}</Empty>

      ) : (

        <div>

          {comments.map((comment) => (

            <CommentItem key={comment._id} comment={comment} onReply={onReply} />

          ))}

        </div>

      )}

    </Section>

  );

}


